module.exports = __webpack_public_path__ + "static/residential_mdu-a92cca8d512289a5bcb9d264966c95eb.jpg";